module.exports = __webpack_public_path__ + "static/media/ironman-head-comics-avatar-iron-man-512.5413ea58.png";